export function isHTMLElement(o: any) {
	return typeof HTMLElement === 'object'
		? o instanceof HTMLElement
		: o &&
				typeof o === 'object' &&
				o !== null &&
				o.nodeType === 1 &&
				typeof o.nodeName === 'string';
}
